import { Utilities, CHECKOUT_DEFAULT_VIEWS, type Checkout } from 'core/domains';

export const initialState: Checkout = {
  rewards: {
    data: {} as Checkout['rewards']['data'],
    message: '',
    status: Utilities.STATUS.IDLE,
    updatedAt: 0,
  },
  step: 'cart',
  views: {
    cart: {
      canSubmit: false,
      completed: false,
      view: CHECKOUT_DEFAULT_VIEWS.cart,
    },
    payment: {
      canSubmit: false,
      completed: false,
      isCreditCardSelected: false,
      view: CHECKOUT_DEFAULT_VIEWS.payment,
    },
    summary: {
      canSubmit: false,
      completed: false,
      view: CHECKOUT_DEFAULT_VIEWS.summary,
    },
  },
  order: {
    code: '',
    errno: null,
    message: '',
    status: Utilities.STATUS.IDLE,
    updatedAt: 0,
  },
  paymentDetail: {
    data: {} as Checkout['paymentDetail']['data'],
    message: '',
    updatedAt: 0,
    status: Utilities.STATUS.IDLE,
  },
  paymentMethods: {
    data: {} as Checkout['paymentMethods']['data'],
    message: '',
    updatedAt: 0,
    status: Utilities.STATUS.IDLE,
  },
  paymentOption: {} as Checkout['paymentOption'],
  isPaymentRequired: true,
  isNotificationVisible: false,
  isGiftSelected: false,
  isReady: false,
  isRunning: false,
  isRetry: false,
  selectedPromotions: [],
  shippingModel: {} as Checkout['shippingModel'],
  specialPaymentsStatus: Utilities.STATUS.IDLE,
};
